// src/modules/phone/phoneService.js
import axios from 'axios';
import { getFeatureFlags, updateFeatureFlags } from '../ai-agent/aiAgentService';

const API_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

const CASCADE_URL = `${API_URL}/communications/ring-cascade`;

// ─── Ring cascade entries ──────────────────────────────────────────────────────
// Note the inconsistent envelopes across these endpoints — list/create/update/
// reorder return the bare resource, delete returns 204 with no body at all.

export const getRingCascade = async () => {
  const response = await axios.get(CASCADE_URL, getHeaders());
  return response.data;
};

export const addToCascade = async (entry) => {
  const response = await axios.post(CASCADE_URL, entry, getHeaders());
  return response.data;
};

export const updateCascadeEntry = async (id, changes) => {
  const response = await axios.put(`${CASCADE_URL}/${id}`, changes, getHeaders());
  return response.data;
};

export const reorderCascade = async (items) => {
  const response = await axios.put(`${CASCADE_URL}/reorder`, { items }, getHeaders());
  return response.data;
};

export const removeFromCascade = async (id) => {
  // 204 No Content — there is no body to return.
  await axios.delete(`${CASCADE_URL}/${id}`, getHeaders());
};

// ─── AI fallback settings ──────────────────────────────────────────────────────

export const getCascadeSettings = async () => {
  const response = await axios.get(`${CASCADE_URL}/settings`, getHeaders());
  return response.data;                       // bare object
};

export const updateCascadeSettings = async (settings) => {
  const response = await axios.put(`${CASCADE_URL}/settings`, settings, getHeaders());
  return response.data.settings;              // enveloped: { success, settings }
};

// ─── The ring_cascade_enabled flag ─────────────────────────────────────────────
// Lives in AIAgentConfig alongside the other feature flags. Values are the
// STRINGS 'true'/'false'. The key is absent until it is first written, and an
// absent key means disabled — hence the `=== 'true'` read rather than a truthiness
// check. updateFeatureFlags accepts a partial object and ignores unknown keys.

export const getRingCascadeEnabled = async () => {
  const flags = await getFeatureFlags();
  return flags.ring_cascade_enabled === 'true';
};

export const setRingCascadeEnabled = async (enabled) => {
  const flags = await updateFeatureFlags({ ring_cascade_enabled: enabled ? 'true' : 'false' });
  return (flags?.config?.ring_cascade_enabled ?? String(enabled)) === 'true';
};
